import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import apiHelper from '../api/ApiHelper';
import { Article, Image, Category } from '../components/types/ArticleTypes';
import './styles/ArticleDetails.css';
import { format } from 'date-fns';

const ArticleDetails: React.FC = () => {
    const { articleId } = useParams<{ articleId: string }>();
    const [article, setArticle] = useState<Article | null>(null);
    const [images, setImages] = useState<Image[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchArticle = async () => {
            try {
                const articleData = await apiHelper.fetchArticle(articleId!);
                setArticle(articleData);
                const imageData = await apiHelper.fetchArticleImages(articleId!);
                setImages(imageData.images);
                setLoading(false);
            } catch (err) {
                if (err instanceof Error) {
                    setError(err.message);
                } else {
                    setError('An error occurred');
                }
                setLoading(false);
            }
        };

        fetchArticle();
    }, [articleId]);

    if (loading) {
        return (
            <div className="article-details-container">
                <div>Loading...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="article-details-container">
                <div>{error}</div>
            </div>
        );
    }

    if (!article) {
        return (
            <div className="article-details-container">
                <div>No article found</div>
            </div>
        );
    }

    return (
        <div className="article-details-container">
            <h1>{article.title}</h1>
            <div className="article-meta">
                <span>{format(new Date(article.createdAt), 'MMMM d, yyyy')}</span>
                {article.categoryName && (
                    <>
                        <span>•</span>
                        <span>{Category[article.categoryName as keyof typeof Category]}</span>
                    </>
                )}
            </div>
            <div className="article-image-container">
                <img src={article.mainImageUrl} alt={article.title} />
            </div>
            <div
                className="article-content"
                dangerouslySetInnerHTML={{ __html: article.content.replace(/\n/g, '<br />') }}
            />
        </div>
    );
};

export default ArticleDetails;